import { Persona } from './persona'

export enum AdditionalField {
  ETHNICITIES = 'ethnicities',
  DISABILITY = 'disability',
  MILITARY_STATUS = 'military_status'
}

export class AdditionalFields {
  public constructor(public readonly values: string[] = []) {
    if (!values || !Array.isArray(values)) {
      values = []
    }
  }

  public contains(rule: AdditionalField): boolean {
    return this.values && this.values.findIndex(v => v === rule) > -1
  }

  public filteredValues(persona: Persona): string[] {
    return this.values.filter((value) =>
      (value === AdditionalField.DISABILITY && !persona.disability) ||
      (value === AdditionalField.ETHNICITIES && !persona.ethnicities.length) ||
      (value === AdditionalField.MILITARY_STATUS && !persona.military_status)
    )
  }
}
